import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolderPaper: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"folder-paper"} maskId="square-filled-radius-0-stroke-1-IconFolderPaper"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H17V5H21V10H22V21H2V7H3V3ZM20 10V6H17V10H20ZM16 10V4H4V7H8.45711L11.4571 10H16Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFolderPaper;
